import { render, staticRenderFns } from "./NovelGroupEditDialog.vue?vue&type=template&id=522ae334&scoped=true"
import script from "./NovelGroupEditDialog.vue?vue&type=script&lang=ts"
export * from "./NovelGroupEditDialog.vue?vue&type=script&lang=ts"
import style0 from "./NovelGroupEditDialog.vue?vue&type=style&index=0&id=522ae334&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "522ae334",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/nola-frontend/nola-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('522ae334')) {
      api.createRecord('522ae334', component.options)
    } else {
      api.reload('522ae334', component.options)
    }
    module.hot.accept("./NovelGroupEditDialog.vue?vue&type=template&id=522ae334&scoped=true", function () {
      api.rerender('522ae334', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ui/dialogs/NovelGroupEditDialog.vue"
export default component.exports